import { render, staticRenderFns } from "./PresenceIndicator.vue.html?vue&type=template&id=72b54bf9&scoped=true&external"
import script from "./PresenceIndicator.vue.js?vue&type=script&lang=js&external"
export * from "./PresenceIndicator.vue.js?vue&type=script&lang=js&external"
import style0 from "./PresenceIndicator.vue.scss?vue&type=style&index=0&id=72b54bf9&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b54bf9",
  null
  
)

export default component.exports